import { SwCategoryProps } from "../../props";
import { CategoryHatchSVG } from "../../icons/hatch-svg";
import styles from "./sw-categories-variant-01.module.scss";
import { CategoryConvertibleSVG } from "../../icons/convertible-svg";
import { CategoryHybridEletricSVG } from "../../icons/hybrid-electric-svg";
import { CategoryMonovolumeSVG } from "../../icons/monovolume.svg";
import { CategoryPeruaSVG } from "../../icons/perua-svg";
import { CategoryPicapeSVG } from "../../icons/picape-svg";
import { CategorySedanSVG } from "../../icons/sedan-svg";
import { CategorySUVSVG } from "../../icons/suv-svg";
import { CategoryVanSVG } from "../../icons/van-svg";
import Link from "next/link";
import { vehicleLinkBuilderByReference } from "@/components/package-components/utils";

export const SwCategoryVariant01 = (props: SwCategoryProps) => {
  const categoriesInStock = new Set(
    (props.data.vehicleList ?? []).map((vehicle) =>
      vehicle.category.toLowerCase()
    )
  );

  const site = props.data.site;

  const availableCategories = [
    "Hatch",
    "Sedan",
    "Picape",
    "SUV",
    "Monovolume",
    "Wagon/Perua",
    "Van",
    "Conversível/Cupê",
    "Hibrido/Elétrico",
  ];

  const renderSVGIcons = (category: string) => {
    switch (category) {
      case "Conversível/Cupê":
        return (
          <CategoryConvertibleSVG
            className={`${styles.icon} icon-${props.id}`}
          />
        );
      case "Hatch":
        return (
          <CategoryHatchSVG className={`${styles.icon} icon-${props.id}`} />
        );
      case "Hibrido/Elétrico":
        return (
          <CategoryHybridEletricSVG
            className={`${styles.icon} icon-${props.id}`}
          />
        );
      case "Monovolume":
        return (
          <CategoryMonovolumeSVG
            className={`${styles.icon} icon-${props.id}`}
          />
        );
      case "Wagon/Perua":
        return (
          <CategoryPeruaSVG className={`${styles.icon} icon-${props.id}`} />
        );
      case "Picape":
        return (
          <CategoryPicapeSVG className={`${styles.icon} icon-${props.id}`} />
        );
      case "Sedan":
        return (
          <CategorySedanSVG className={`${styles.icon} icon-${props.id}`} />
        );
      case "SUV":
        return <CategorySUVSVG className={`${styles.icon} icon-${props.id}`} />;
      case "Van":
        return <CategoryVanSVG className={`${styles.icon} icon-${props.id}`} />;
      default:
        break;
    }
  };

  const renderLabelForSVGIcons = (category: string) => {
    switch (category) {
      case "Conversível/Cupê":
        return "Conversível/Cupê";
      case "Hatch":
        return "Hatch";
      case "Hibrido/Elétrico":
        return "Híbrido/Elétrico";
      case "Monovolume":
        return "Monovolume";
      case "Wagon/Perua":
        return "Perua";
      case "Picape":
        return "Picape";
      case "Sedan":
        return "Sedan";
      case "SUV":
        return "SUV";
      case "Van":
        return "Van";
      default:
        break;
    }
  };

  return (
    <section className={`${styles.section} section-${props.id}`}>
      <div className={`${styles.container} container-${props.id}`}>
        <h1 className={`${styles.title} title-${props.id}`}>
          Compre por Categoria
        </h1>

        <div
          className={`${styles.content__container} content__container-${props.id}`}
        >
          {availableCategories.map((category, index) => {
            if (!categoriesInStock.has(category.toLowerCase())) {
              return;
            }

            const currentLink =
              vehicleLinkBuilderByReference({
                ref: "category",
                value: category,
                site: {
                  subdomain: site?.subdomain as string,
                  customDomain: site?.customDomain ?? "",
                  preferences: site?.preferences ?? [],
                },
                vehicleList: props.data.vehicleList,
              }) ?? "/";

            return (
              <Link
                href={currentLink}
                className={`${styles.card__wrapper} card__wrapper-${props.id}`}
                prefetch
              >
                <div
                  className={`${styles.card} card-${props.id}`}
                  key={`${category}-card-${index}`}
                >
                  {renderSVGIcons(category)}
                  <p>{renderLabelForSVGIcons(category)}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
